import {SET_FEATURES, CLEAR_FEATURES} from 'actions/types';

var featuresInitialState = {list:[], indexed:{}, loaded:false};

export default (state = featuresInitialState, action) => {
    switch(action.type) {
        case SET_FEATURES: 
            return {...state,
                    list:action.features.map((c)=>(c.id)),
                    indexed: action.features.reduce((m,c)=>{m[c.id]=c;return m;},action.replace ? {} : {...state.indexed}),
                    loaded:true
                    };
        case CLEAR_FEATURES: 
            return featuresInitialState;
        default:            
            return state;
    }
}


//selectors
export const isListLoaded = state => state.loaded;
export const getFeatures = state => state.list.map( id => state.indexed[id] );
export const areFeaturesLoaded = state => state.loaded;

export const getFeatureByTag = (state, tag) => {
	return getFeatures(state).filter((plugin)=>(plugin.tag===tag))[0]; // prettier but way less efficient than a simple loop
};

export const getFeaturePluginSetting = (state, tag, attribute) => {
	var feature = getFeatureByTag(state, tag); // prettier but way less efficient than a simple loop
	if(feature && feature.pluginSettings) {
        return feature.pluginSettings[attribute];
	}
};



// WEBPACK FOOTER //
// ./src/reducers/features.js